module.exports = __webpack_public_path__ + "LatoLatin-Regular.586ec8dc57c264cffafa.woff";


//////////////////
// WEBPACK FOOTER
// /Users/davidkross/Project/TaiwaneseTutor/front-end/TaiwaneseTutor/src/assets/fonts/LatoLatin/fonts/LatoLatin-Regular.woff
// module id = ../../../../../src/assets/fonts/LatoLatin/fonts/LatoLatin-Regular.woff
// module chunks = styles